import { render, staticRenderFns } from "./InstalledModal.vue?vue&type=template&id=5c427754&scoped=true"
import script from "./InstalledModal.vue?vue&type=script&lang=ts"
export * from "./InstalledModal.vue?vue&type=script&lang=ts"
import style0 from "./InstalledModal.vue?vue&type=style&index=0&id=5c427754&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c427754",
  null
  
)

export default component.exports